import moment from 'moment';

const formatter = {
  formatFromTarget: target => {
    let value;
    switch (target.type) {
      case 'checkbox':
        value = target.checked;
        break;
      case 'number':
        value = Number(target.value);
        break;
      case 'react-datetime':
        value = moment(target.value).toISOString();
        break;
      default:
        value = target.value;
    }
    return value;
  },

  formatDateForAPI: date => {
    return moment(date).toISOString(); //.format('YYYY-MM-DDTHH:mm:ss.sss');
  },

  formatDate: date => {
    return moment(date).format('DD/MM/YYYY');
  },

  formatDateTime: date => {
    return moment(date).format('DD/MM/YYYY HH:mm:ss');
  },

  formatNumber: number => {
    // Check if the number has decimals
    const hasDecimals = number % 1 !== 0;

    // Format the integer part with dots
    const integerPart = Math.floor(number).toString();
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    // Return the formatted number based on whether it has decimals
    if (hasDecimals) {
      const decimalPart = number.toFixed(2).split('.')[1]; // Extract decimal part
      return `${formattedInteger},${decimalPart}`;
    }

    return formattedInteger;
  },

  formatLanguage: cardLanguage => {
    switch (cardLanguage) {
      case 'ESP':
        return 'Español';
      case 'ING':
        return 'Inglés';
      case 'POR':
        return 'Portugués';
      case 'CHI':
        return 'Chino';
      case 'ITA':
        return 'Italiano';
      case 'FRA':
        return 'Francés';
      case 'ALE':
        return 'Alemán';
      case 'RUS':
        return 'Ruso';
      case 'KOR':
        return 'Coreano';
      case 'JAP':
        return 'Japonés';
      case 'RANDOM':
        return 'Aleatorio';
      default:
        return cardLanguage;
    }
  },
};

export default formatter;
